export function isLogin(state) {
  return state.isLogin;
}

export function showLogin(state) {
  return state.showLogin;
}

export function loginTo(state) {
  return state.loginTo;
}

export function redirectPath(state) {
  return state.redirectPath;
}

export function showRegister(state) {
  return state.showRegister;
}

export function userInfo(state) {
  return state.userInfo;
}

export function lang(state) {
  return state.lang;
}

export function isPushWhatsApp(state) {
  return state.isPushWhatsApp;
}
